import gql from 'graphql-tag';

export const SITES = gql`
  query Sites {
    context {
      siblings
      host
    }
  }
`;